module.exports = __webpack_public_path__ + "img/logo.9abe33a6.png";